import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { DirectionalLight as BaseDirectionalLight } from '@luma.gl/core';

var DirectionalLight = function (_BaseDirectionalLight) {
  _inherits(DirectionalLight, _BaseDirectionalLight);

  function DirectionalLight(props) {
    var _this;

    _classCallCheck(this, DirectionalLight);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DirectionalLight).call(this, props));

    var _props$_shadow = props._shadow,
        _shadow = _props$_shadow === void 0 ? false : _props$_shadow;

    _this.shadow = _shadow;
    return _this;
  }

  _createClass(DirectionalLight, [{
    key: "getProjectedLight",
    value: function getProjectedLight() {
      return this;
    }
  }]);

  return DirectionalLight;
}(BaseDirectionalLight);

export { DirectionalLight as default };
//# sourceMappingURL=directional-light.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deck.gl/core/dist/esm/effects/lighting/directional-light.js
// module id = 288
// module chunks = 0